import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Tags = ({
  label = "",
  placeholder = "Select items",
  onChange = () => {},
  onKeyDown = () => {},
  options = [],
  selectedItems = [],
  setSelectedItems = () => {},
  labelClass = "",
  tagsType = "input",
  tabIndex,
  dropdownEnabled = true, // ✅ New prop (default is true)
}) => {
  const selectRef = useRef(null);
  const [keyWord, setKeyword] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    if (!dropdownEnabled) return; // ✅ Skip filtering if dropdown is disabled

    let updatedOptions = options;
    if (keyWord) {
      updatedOptions = updatedOptions.filter((item) => item.label.toLowerCase().includes(keyWord.toLowerCase()));
    }
    updatedOptions = updatedOptions.filter(
      (item) => !selectedItems?.some((selected) => selected?.label === item?.label)
    );
    setFilteredOptions(updatedOptions);
  }, [keyWord, options, selectedItems, dropdownEnabled]);

  useEffect(() => {
    onChange(selectedItems);
  }, [selectedItems, onChange]);

  const selectHandler = (data) => {
    const updated = [...selectedItems, data];
    setSelectedItems(updated);
    setKeyword("");
    setToggle(false);
  };

  const keywordHandler = (e) => {
    setKeyword(e.target.value);
  };

  const addTagHandler = () => {
    if (tagsType === "input" && keyWord) {
      if (selectedItems.some((item) => item.label.toLowerCase() === keyWord.toLowerCase())) {
        toast.error("Tag already exists!");
        return;
      }

      const newTag = { label: keyWord };
      const updated = [...selectedItems, newTag];
      setSelectedItems(updated);
      setKeyword("");
    }
  };

  const removeTagHandler = (idOrLabel) => {
    const updated = selectedItems.filter((item) => item._id !== idOrLabel && item.label !== idOrLabel);
    setSelectedItems(updated);
  };

  return (
    <div className="w-full relative">
      <div className="relative" ref={selectRef}>
        {label && (
          <div className={`text-xs font-medium text-text-disabled mb-1  ${labelClass}`}>{label}</div>
        )}
        <div
          onClick={() => dropdownEnabled && setToggle(!toggle)} // ✅ Toggle only if dropdown is enabled
          className="flex flex-wrap border border-slate-300/70 px-2 py-1 rounded-md min-h-[40px] focus-within:border-primary focus-within:shadow-lg">
          <div className="flex flex-wrap gap-[2px] w-full">
            {selectedItems.map((item) => (
              <span
                key={item._id || item.label}
                className="flex gap-1 px-1 py-[2px] text-[12px] rounded-md whitespace-nowrap w-fit h-7 border border-primary bg-gray-200 justify-center items-center">
                <span>{item.label}</span>
                <span
                  onClick={() => removeTagHandler(item._id || item.label)}
                  className="cursor-pointer w-fit h-fit flex">
                  <i className="fa-fw fa-light fa-close"></i>
                </span>
              </span>
            ))}
            <div className="flex items-center relative w-full">
              <div className="relative w-full h-7">
                <input
                  className="w-full h-full p-0 border-0 outline-none ring-0 focus:ring-0 focus:border-0 placeholder:text-sm placeholder:text-text-disabled pl-2 pr-6"
                  onChange={keywordHandler}
                  placeholder={tagsType === "input" ? (selectedItems?.length >= 1 ? "" : placeholder) : "Search items"}
                  value={keyWord}
                  tabIndex={tabIndex}
                  onKeyDown={(e) => {
                    if (e.code === "Enter") {
                      e.preventDefault();
                      onKeyDown({ code: "Enter" });
                      addTagHandler();
                    } else {
                      onKeyDown(e);
                    }
                  }}
                />
              </div>
              <div
                onClick={addTagHandler}
                className="bg-primary text-white p-1 w-5 h-5 flex items-center justify-center rounded-sm cursor-pointer absolute right-1 top-1"
                title="add tag">
                +
              </div>
            </div>
          </div>
        </div>

        {dropdownEnabled && toggle && (
          <div className="shadow absolute top-full mt-2 w-full rounded-md bg-white overflow-y-auto max-h-60 z-10">
            {filteredOptions.length > 0 ? (
              <ul>
                {filteredOptions.map((item) => (
                  <li
                    key={item._id}
                    onClick={() => selectHandler(item)}
                    className="capitalize relative select-none py-2 pl-2 pr-2 text-xs leading-tight cursor-pointer transition-all duration-200 text-slate-500 hover:bg-primary hover:text-gray-15">
                    <div className="flex gap-2 items-center">
                      <span className="w-5 h-5 flex items-center justify-center"></span>
                      <span>{item.label}</span>
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              <div className="p-4 text-sm text-slate-400">No items found</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Tags;
